import { render, staticRenderFns } from "./industryList.vue?vue&type=template&id=f1cb7496&scoped=true&"
import script from "./industryList.vue?vue&type=script&lang=js&"
export * from "./industryList.vue?vue&type=script&lang=js&"
import style0 from "./industryList.vue?vue&type=style&index=0&id=f1cb7496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cb7496",
  null
  
)

export default component.exports